import { render, staticRenderFns } from "./washLabel.vue?vue&type=template&id=1dcb98c6&scoped=true&"
import script from "./washLabel.vue?vue&type=script&lang=js&"
export * from "./washLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb98c6",
  null
  
)

export default component.exports